module.exports = __webpack_public_path__ + "media/src/images/top_covers/com_autumn_02-28ee66ced296ad35fe98af7259cb7940.png";